import React from 'react';
import QuoteRequestForm from '../../components/quote/QuoteRequestForm';

export default function NewOrderPage() {
  return <QuoteRequestForm />;
}
